import { Types } from '@store/types';

const initialState = { response: {}, filterField: {}, countResponse: {}, selectedProducts: [] };

const SampleReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_ALL_SAMPLE_BY_STATUS: {
			let data = [];
			if (action.payload.merge === true) {
				data = [...state.response.data, ...action.payload.data.data];
			} else {
				data = [...action.payload.data.data];
			}
			let response = action.payload.data;
			response.data = data;
			return { ...state, response: response };
		}
		case Types.SET_SAMPLE_REQUEST_FILTER_DATA:
			return { ...state, filterField: { ...action.payload } };
		case Types.SET_SAMPLE_REQUEST_COUNT:
			return { ...state, countResponse: { ...action.payload } };
		case Types.FETCH_SAMPLE_PRODUCTS:
			return { ...state, selectedProducts: [...action.payload] };
		case Types.SET_READ_SAMPLE_REQUEST_COMMENT: {
			let cloneResponse = { ...state.response };
			if (cloneResponse?.data) {
				for (let item of cloneResponse.data) {
					if (item.id === action.payload) {
						item.noOfUnreadMessage = 0;
					}
				}
			}
			return { ...state, response: cloneResponse };
		}
		case Types.CLEAR_SAMPLE_REQUEST:
			return (state = { response: {}, filterField: {}, countResponse: {}, selectedProducts: [] });
		default:
			return state;
	}
};

export default SampleReducer;
